import { levelCostIncrement, baseLevelCost, levelCostMultiplier } from '../Constants/Level';
import { ILevelDataFile } from '../System/Level/Data/ILevelDataFile';
import { report } from '../report';
import { replayCostMultiplier } from '../Constants/Economy';
import { FTUXFreeLevels } from '../Constants/FTUX';
import { CardType } from 'Prototype/Level/Card/CardType';
import { ArrayHelper } from './ArrayHelper';
import { ICardData } from 'Prototype/Level/Card/ICardData';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import Sprite from 'Prototype/Sprite';
import PIXIRenderer from 'System/Render/PIXIRenderer';
import levelsData from '../../resource/data/levelsData.json';

export default class LevelHelper {
    // This method should be used for rewards calculations, that depend on level entry cost
    public static getLevelCost(levelNumber: number, applyReplayDiscount: boolean = false): number {
        const increments: number = Math.floor((levelNumber - 1) / levelCostIncrement);
        return Math.round(
            (baseLevelCost + increments * levelCostMultiplier) * (applyReplayDiscount ? replayCostMultiplier : 1)
        );
    }

    // This method can return 0. Should be used for entry price calculations
    public static getLevelEntryCost(levelNumber: number, applyReplayDiscount: boolean = false): number {
        if (levelNumber <= FTUXFreeLevels && !applyReplayDiscount) {
            return 0;
        }

        return LevelHelper.getLevelCost(levelNumber, applyReplayDiscount);
    }

    public static getUniqueCardTypes(cards: ICardData[]): CardType[] {
        return cards.map(card => card.type).filter(ArrayHelper.filterOnce);
    }

    public static getUniqueCardModifierTypes(cards: ICardData[]): CardModifierType[] {
        // Flatten individual modifier arrays to single array 
        return ArrayHelper.flatten(
            // Get array of modifier types for each card
            cards.map(card => card.modifiers.map(modifier => modifier.type))
            // Filter out duplicates
        ).filter(ArrayHelper.filterOnce);
    }
}

export function getEpisodeIndex(levelDataSettings: Pick<ILevelDataFile['settings'], 'background'>): number {
    // FIXME: don't extract episode from backgound image!
    const matchResult = levelDataSettings.background.match(/^episode_(\d+)\.jpg$/);
    if (!matchResult) {
        report('Failed to get episode index', {
            once: true,
            sampleRate: 0.1,
            tags: {
                background: levelDataSettings.background,
            },
        });
        return -1;
    }
    return Number(matchResult[1]) - 1;
}

export function scaleSpriteToScreen(elm: Sprite) {
    const scaleW = PIXIRenderer.renderer.width / elm.container.width;
    const scaleH = PIXIRenderer.renderer.height / elm.container.height;
    if (scaleW > scaleH) {
        elm.container.scale.set(scaleW);
    } else {
        elm.container.scale.set(scaleH);
    }
}

export function isHardLevel(levelNumber: number): boolean {
    return levelsData.hardLevels.includes(levelNumber);
}
